import React from  'react';

// components
import Couple from '../../components/couple';
import HeroMain from '../../components/HeroMain';
import Story from '../../components/story';
import Welcome from '../../components/welcome-area';
import Location from '../../components/location';
import Rsvp from '../../components/rsvp';
import Navbar from '../../components/Navbar'
import Saveday from '../../components/countdown'
import Footer from '../../components/footer'
import Gallery from '../../components/gallery'
import PublicDevtoolsGuard from '../../components/publicDevtoolsGuard';
import { useSiteSettings } from '../../siteSettings';


const HomeMain = () => {
    const settings = useSiteSettings();
    const defaultLayout = [
        { id: 'hero', visible: true },
        { id: 'countdown', visible: true },
        { id: 'couple', visible: true },
        { id: 'welcome', visible: true },
        { id: 'story', visible: true },
        { id: 'event', visible: true },
        { id: 'gallery', visible: true },
        { id: 'rsvp', visible: true },
        { id: 'footer', visible: true },
    ];
    const savedLayout = settings.sectionLayout && settings.sectionLayout.length ? settings.sectionLayout : defaultLayout;
    const rsvpIndex = savedLayout.findIndex((item) => item.id === 'rsvp');
    const layout = savedLayout.some((item) => item.id === 'gallery') ? savedLayout : [...savedLayout.slice(0, rsvpIndex < 0 ? savedLayout.length : rsvpIndex), { id: 'gallery', visible: true }, ...savedLayout.slice(rsvpIndex < 0 ? savedLayout.length : rsvpIndex)];
    const sections = {
        hero: <HeroMain />,
        countdown: <Saveday saveday={'s2'} />,
        couple: <Couple couple={'s2'} />,
        welcome: <Welcome welcome={'s2'} />,
        story: <Story />,
        event: <Location />,
        gallery: <Gallery />,
        rsvp: <Rsvp />,
        footer: <Footer footer={'s2'} />,
    };

    return(
       <div>
           <PublicDevtoolsGuard />
           <Navbar/>
           {layout.filter((item) => item.visible !== false && sections[item.id]).map((item) => <React.Fragment key={item.id}>{sections[item.id]}</React.Fragment>)}
       </div>
    )
}

export default HomeMain;
